export const STATUS_LABELS = {
  uploading: 'In Progress',
  detected: 'Ready',
  in_review: 'Review',
  approved: 'Approved',
  published: 'Published',
} as const

export const STATUS_COLORS = {
  uploading: '#e67e22',
  detected: '#27ae60',
  in_review: '#c0392b',
  approved: '#2980b9',
  published: '#8e44ad',
} as const

export const STATUS_INDICATORS = {
  uploading: '⏳',
  detected: '🟢',
  in_review: '🟡',
  approved: '✅',
  published: '📤',
} as const
